<div class="row row-cols-1 row-cols-sm-4 g-4 mt-1">
  <div class="col">
    <div class="rounded-lg shadow-sm p-2 card-header-primary bg-opacity-10 text-center d-flex flex-column justify-content-center">
      <div class="fw-bold text-success fs-4 mb-2">{{ compliance_counts.COMPLIANT || 0 }}</div>
      <div class="text-dark text-x fw-bold">Compliant</div>
    </div>
  </div>
  <div class="col">
    <div class="rounded-lg shadow-sm p-2 card-header-primary bg-opacity-10 text-center d-flex flex-column justify-content-center">
      <div class="fw-bold text-danger fs-4 mb-2">{{ compliance_counts.NON_COMPLIANT || 0 }}</div>
      <div class="text-dark text-x fw-bold">Non-Compliant</div>
    </div>
  </div>
  <div class="col">
    <div class="rounded-lg shadow-sm p-2 card-header-primary bg-opacity-10 text-center  d-flex flex-column justify-content-center">
      <div class="fw-bold text-info fs-4 mb-2">{{ compliance_counts.GRACE_PERIOD || 0 }}</div>
      <div class="text-dark text-x fw-bold">Risk</div>
    </div>
  </div>
  <div class="col">
    <div class="rounded-lg shadow-sm p-2 card-header-primary bg-opacity-10 text-center  d-flex flex-column justify-content-center">
      <div class="fw-bold text-warning fs-4 mb-2">{{ compliance_counts.PENDING || 0 }}</div>
      <div class="text-dark text-x fw-bold">Pending</div>
    </div>
  </div>
</div>

<div class="px-1 mt-4">
  <div class="card  rounded-lg border-0">
    <div
      class="card-header bg-white border-0 py-3 d-flex justify-content-between align-items-center cursor-pointer"
      @click="toggle_tab('Forms')"
    >
      <p class="mb-0 fw-bold">Forms</p>
      <i class="bx fs-5" :class="active_tabs.includes('Forms') ? 'bx-chevron-up' : 'bx-chevron-down'"></i>
    </div>
    <div class="mt-0 collapse" :class="{ 'show': active_tabs.includes('Forms') }">
      <div class="card-body">
        <ComplianceMonitoring
          :programs="grouped_programs"
          :fetchAnswers="fetch_answers"
          :fetchChecks="fetch_checks"
        />
      </div>
    </div>
  </div>

  <div class="d-none card shadow-sm rounded-5 mb-3 mt-5 border table-border-color">
    <div
      class="card-header bg-white border-0 py-3 d-flex justify-content-between align-items-center cursor-pointer"
      @click="toggle_tab('Notifications')"
    >
      <p class="mb-0 fw-bold">Notifications</p>
      <i class="bx fs-5" :class="active_tabs.includes('Notifications') ? 'bx-chevron-up' : 'bx-chevron-down'"></i>
    </div>
    <div class="collapse" :class="{ 'show': active_tabs.includes('Notifications') }">
      <div class="card-body">
        <ComplianceNotifications />
      </div>
    </div>
  </div>
</div>

<div class="d-none compliance-overview container-md">
  <div class="quick-tip rounded-lg mb-4 shadow-sm">
    <p class="text-xxs fw-bold">
      This view shows only requirements subject to compliance monitoring.
      Click on each requirement to view submissions and its compliance.
    </p>
  </div>

  <div v-if="loading_questions" class="card p-4 mb-3 text-center">
    <div class="d-flex justify-content-center align-items-center py-4">
      <div class="spinner-border text-primary me-3" role="status"></div>
      <div>
        <p class="mb-1 text-xs fw-bold">Loading compliance data...</p>
        <p class="mb-0 text-xxs text-muted">Please wait while we fetch your compliance information</p>
      </div>
    </div>
  </div>

  <div v-else-if="!loading_questions && questions.length === 0" class="card p-4 mb-3 text-center border-primary">
    <div class="py-4">
      <i class="fas fa-info-circle text-muted mb-3"></i>
      <h6 class="text-muted">No Compliance Data Found</h6>
      <p class="text-xxs text-muted mb-0">
        No requirements with compliance monitoring are available for this entity.
      </p>
    </div>
  </div>

  <div v-else class="list-group">
    <div
      v-for="(question, index) in questions"
      :key="`question-${index}`"
      class="list-group-item border table-border-color p-4 position-relative"
      :class="{ 'bg-light-green': expanded_question_index === index }"
      @click.stop="toggle_question_expansion(question.id)"
    >
      <span
        class="status-badge position-absolute text-xxs fw-bold px-2 py-1 rounded"
        :class="get_question_status_class(question)"
        style="top: 0.5rem; right: 2.5rem; z-index: 1;"
      >
        {{ get_question_status_text(question) }}
      </span>

      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div>
            <p class="mb-1 text-xs fw-bold">{{ question.question_text }}</p>
            <p class="text-xxs text-muted mb-0">
              {{ question.section_name }} • {{ question.form_name }}
            </p>
          </div>
        </div>
      </div>

      <div v-if="expanded_question_index === index" class="mt-4">
        <div v-if="question.loading_answers" class="text-center py-3">
          <div class="spinner-border spinner-border-sm text-primary me-2"></div>
          <span class="text-xs">Loading submissions...</span>
        </div>

        <div v-else>
          <div v-if="question.answers.length === 0" class="text-center py-2">
            <p class="text-xs text-muted">No submissions</p>
          </div>

          <div v-else>
            <div
              v-for="(answer, a_index) in question.answers"
              :key="`answer-${a_index}`"
              class="answer-card p-3 mb-3 rounded border bg-white"
            >
              <div class="d-flex justify-content-between align-items-center"
                   @click.stop="toggle_answer_history(question, answer)"
              >
                <div>
                  <p class="mb-1 text-xs fw-bold">
                    <i class="fas fa-file-pdf text-danger me-1"></i>
                    {{ extract_file_name(answer.answer) }}
                  </p>
                  <p class="text-xxs text-muted mb-0">
                    Uploaded: {{ format_date(answer.date_answered) }}
                  </p>
                </div>
              </div>

              <div v-if="answer.show_history" class="mt-3">
                <div v-if="answer.loading_checks" class="text-center py-2">
                  <div class="spinner-border spinner-border-sm text-secondary me-2"></div>
                  <span class="text-xxs">Loading checks...</span>
                </div>

                <div v-else>
                  <div v-if="answer.checks.length === 0" class="text-center py-2">
                    <p class="text-xxs text-muted">No compliance checks available</p>
                  </div>

                  <div v-else>
                    <p class="fw-bold border-bottom pb-2 mb-3 text-xs">Compliance History</p>

                    <div
                      v-for="(check, c_index) in answer.checks"
                      :key="`check-${c_index}`"
                      class="compliance-event mb-3 p-3 border rounded bg-white shadow-sm"
                      :class="get_history_status_class(check)"
                    >
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <div class="d-flex align-items-center gap-2">
                          <span
                            class="status-badge text-xxs fw-bold px-2 py-1 rounded"
                            :class="get_history_badge_class(check.status)"
                          >
                            {{ get_history_status_label(check) }}
                          </span>
                          <span class="text-xxs badge bg-light text-dark border">
                            <i class="fas fa-code-branch me-1"></i>
                            Rule v{{ check.compliance_rule?.version || 'N/A' }}
                          </span>
                        </div>
                        <span class="text-xxs text-muted">
                         Check #{{ check.id || 'N/A' }}
                        </span>
                      </div>

                      <div v-if="check.compliance_rule" class="rule-info mb-2 p-2 bg-light rounded">
                        <p class="text-xxs mb-1">
                          <i class="fas fa-cog me-1"></i>
                          <strong>Rule:</strong> {{ check.compliance_rule.name }}
                        </p>
                        <p class="text-xxs mb-0 text-muted">
                          {{ check.compliance_rule.description }}
                        </p>
                      </div>

                      <div class="check-details">
                        <p class="text-xxs mb-1">
                          <i class="fas fa-calendar-alt me-1"></i>
                          <strong>Checked:</strong> {{ format_date(check.checked_at) }}
                        </p>
                        <p class="text-xxs mb-1">
                          <i class="fas fa-clock me-1"></i>
                          <strong>Next Check:</strong> {{ format_date(check.next_check_date) }}
                        </p>
                      </div>
                    </div>

                    <div v-if="answer.checks_pagination.has_more" class="text-center mt-2">
                      <button
                        class="btn btn-sm btn-outline-dark"
                        @click="fetch_checks_for_answer(question, answer, answer.checks_pagination.next_page)"
                        :disabled="answer.loading_checks"
                      >
                        View More Checks
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="question.answers_pagination.has_more" class="text-center mt-3">
              <button
                class="btn btn-sm btn-outline-primary"
                @click="fetch_answers_for_question(question, question.answers_pagination.next_page)"
                :disabled="question.loading_answers"
              >
                View More Submissions
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="questions_pagination.has_more" class="text-center mt-4">
      <button
        class="btn btn-primary"
        @click="fetch_questions(questions_pagination.next_page)"
        :disabled="loading_questions"
      >
        View More Requirements
      </button>
    </div>
  </div>
</div>